import styled from "styled-components"
import {
  jd100Origin,
  jd50Origin,
  aqyOrigin,
  walmartOrigin,
  txOrigin,
} from "../../images"

const ProgressBar = styled.div`
  position: relative;
  width: ${(props) => props.width + "%"};
  height: 0.11rem;
  background: #1db5f4;
  transition: width 800ms ease-in-out;
`

const IndicatorWrap = styled.div`
  position: relative;
  width: ${(props) => props.width + "%"};
`

const ProgressIndicator = styled.div`
  position: absolute;
  top: -0.44rem;
  right: -0.1rem;
  width: 0.34rem;
  height: 0.34rem;
  background: ${(props) =>
    props.width !== 100
      ? props.width >= 90
        ? `url(https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/pace.gif)`
        : `url(https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/walk.gif)`
      : `url(https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/success.gif)`};
  opacity: ${(props) => (props.showGif === true ? 1 : 0)};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`
const ProgressText = styled.div`
position: absolute;
  top: -0.11rem;
  right: -0.1rem;
  opacity: ${(props) => (props.showGif === true ? 1 : 0)};
  &::after {
    position: absolute;
    top: 0;
    right: 0.14rem;
    content: "${(props) => props.width}";
    color: #ade7ff;
    font-size: 0.12rem;
  }

`

const Avatar = styled.div`
  background-image: ${(props) => `url(${props.avatarUrl})`};
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  height: 0.36rem;
  width: 0.36rem;
`
const StorageBar = styled.div`
  position: relative;
  width: ${(props) => props.width + "%"};
  height: 0.08rem;
  background: #1db5f4;
  transition: width 800ms ease-in-out;
`

const Storage = styled.div`
  font-size: 0.1rem;
  color: ${(props) =>
    props.storage === 0
      ? `#929292`
      : +props.storage >= 10
      ? `#1DB5F4`
      : `#EE4F52`};
  font-weight: lighter;
`

const PrizeImage = styled.div`
  width: 100%;
  height: 2.08rem;
  background: ${(props) =>
    props.giftCode === "WBX-JDK100"
      ? `url(${jd100Origin})`
      : props.giftCode === "WBX-JDK50"
      ? `url(${jd50Origin})`
      : props.giftCode === "WBX-TXSP"
      ? `url(${txOrigin})`
      : props.giftCode === "WBX-AQYSP"
      ? `url(${aqyOrigin})`
      : `url(${walmartOrigin})`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`

export {
  ProgressBar,
  ProgressIndicator,
  IndicatorWrap,
  Avatar,
  Storage,
  StorageBar,
  PrizeImage,
  ProgressText,
}
